import {
  FormFieldBlueprint,
  createFormField,
} from '@backstage/plugin-scaffolder-react/alpha';
import { makeFieldSchema } from '@backstage/plugin-scaffolder-react';
import type { FieldValidation } from '@rjsf/utils';
import { GitLabProjectPicker } from './GitLabProjectPicker';
import { GitLabProjectData } from './types';

function validateGitLabProjectPicker(
  value: GitLabProjectData | GitLabProjectData[] | undefined,
  validation: FieldValidation,
  schema: { type?: string } | undefined,
) {
  const isMultiple = schema?.type === 'array';

  if (!value) {
    validation.addError(
      isMultiple
        ? 'Selecione pelo menos um projeto GitLab'
        : 'Selecione um projeto GitLab',
    );
    return;
  }

  const projects = Array.isArray(value) ? value : [value];

  if (isMultiple && projects.length === 0) {
    validation.addError('Selecione pelo menos um projeto GitLab');
    return;
  }

  projects.forEach((project, index) => {
    if (!project.projectId) {
      validation.addError(
        `Projeto ${index + 1} inválido: projectId é obrigatório`,
      );
    }
    if (!project.pathWithNamespace) {
      validation.addError(
        `Projeto ${index + 1} inválido: pathWithNamespace é obrigatório`,
      );
    }
    if (!project.name) {
      validation.addError(`Projeto ${index + 1} inválido: name é obrigatório`);
    }
  });
}

export const GitLabProjectPickerFieldExtension = FormFieldBlueprint.make({
  name: 'gitlab-project-picker',
  params: {
    field: async () =>
      createFormField({
        name: 'GitLabProjectPicker',
        component: GitLabProjectPicker as any,
        validation: (value, validation, { schema }) =>
          validateGitLabProjectPicker(
            value as GitLabProjectData | GitLabProjectData[] | undefined,
            validation,
            schema as { type?: string },
          ),
        schema: makeFieldSchema({
          output: z => z.unknown(),
          uiOptions: z =>
            z.object({
              host: z
                .string()
                .optional()
                .describe('GitLab host used to list projects'),
              placeholder: z
                .string()
                .optional()
                .describe('Placeholder shown in the project filter field'),
              noOptionsText: z
                .string()
                .optional()
                .describe('Message shown when no projects match the filter'),
            }),
        }),
      }),
  },
});
